<div class="align-h margin-top-20" *ngIf="subType && (years?.length> 0 || months?.length > 0)">
    <div class="form-group stretch margin-bottom-0 margin-right-30" *ngIf="years?.length> 0" >
        <mat-form-field class="font-18">
            <mat-label>Year</mat-label>
            <mat-select
                disableOptionCentering
                [(ngModel)]="subType.selectedYear"
                name="year"
                #year="ngModel"
                (selectionChange)="onYearChange($event)"
            >
                <mat-option
                    *ngFor="let year of years"
                    [value]="year"
                >
                    {{ year }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="form-group stretch margin-bottom-0"  *ngIf="months?.length> 0">
        <mat-form-field class="font-18">
            <mat-label>Month</mat-label>
            <mat-select
                disableOptionCentering
                [(ngModel)]="subType.selectedMonth"
                name="month"
                #month="ngModel"
                (selectionChange)="onMonthChange($event)"
            >
                <mat-option
                    *ngFor="let month of months"
                    [value]="month"
                >
                    {{ month }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>